import {
  INCIDENT_DETAIL_BODY_BASE_PATH,
  INCIDENT_DETAIL_INITIAL_VISIT_BASE_PATH,
  INCIDENT_DETAIL_PROPERTY_BASE_PATH,
  INCIDENT_SHOW_DETAIL_BODY_BASE_PATH,
  INCIDENT_SHOW_DETAIL_INITIAL_VISIT_BASE_PATH,
  INCIDENT_SHOW_DETAIL_PROPERTY_BASE_PATH,
} from '@/modules/adjusterReportModules/IncidentDetails/IncidentDetailsLinks';
import AccidentDetailsBody from '@/modules/adjusterReportModules/IncidentDetails/pages/accidentDetailsBody/accidentDetailsBody';
import AccidentDetailsShowBody from '@/modules/adjusterReportModules/IncidentDetails/pages/accidentDetailsBody/AccidentDetailsShowBody';
import InitialVisitDetails from '@/modules/adjusterReportModules/IncidentDetails/pages/initialVisitDetails/incidentDetailsInitial';
import { IncidentShowDetailsInitial } from '@/modules/adjusterReportModules/IncidentDetails/pages/initialVisitDetails/IncidentShowDetailsInitial';
import { PropertyDamageDetails } from '@/modules/adjusterReportModules/IncidentDetails/pages/propertyDamageDetails/propertyDamageDetails';
import { PropertyDamageShowDetails } from '@/modules/adjusterReportModules/IncidentDetails/pages/propertyDamageDetails/PropertyDamageShowDetails';
import { RouteObject } from 'react-router-dom';

export const IncidentDetailsRoutes: RouteObject[] = [
  {
    path: INCIDENT_DETAIL_PROPERTY_BASE_PATH,
    element: <PropertyDamageDetails />,
  },
  { path: INCIDENT_DETAIL_BODY_BASE_PATH, element: <AccidentDetailsBody /> },
  {
    path: INCIDENT_DETAIL_INITIAL_VISIT_BASE_PATH,
    element: <InitialVisitDetails />,
  },
  {
    path: INCIDENT_SHOW_DETAIL_PROPERTY_BASE_PATH,
    element: <PropertyDamageShowDetails />,
  },
  {
    path: INCIDENT_SHOW_DETAIL_BODY_BASE_PATH,
    element: <AccidentDetailsShowBody />,
  },
  {
    path: INCIDENT_SHOW_DETAIL_INITIAL_VISIT_BASE_PATH,
    element: <IncidentShowDetailsInitial />,
  },
];
